import { useEffect } from "react";
import { COMPANY } from "../lib/constants";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-heading text-xl font-bold text-brand-green">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-brand-muted">{children}</div>
  </div>
);

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy | KAC — Krishnaa Constructions";
  }, []);
  return (
    <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6" data-testid="privacy-page">
      <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-green2">Legal</p>
      <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-brand-green">Privacy Policy</h1>
      <p className="mt-4 text-sm text-brand-muted">Last updated: July 2026</p>

      <Section title="Who we are">
        <p>
          This website is operated by {COMPANY.name} (KAC), a building company based in the United Kingdom. You can contact
          us about this policy at <a className="font-semibold text-brand-green underline underline-offset-2" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> or
          on <a className="font-semibold text-brand-green underline underline-offset-2" href={`tel:${COMPANY.phone}`}>{COMPANY.phoneDisplay}</a>.
        </p>
      </Section>

      <Section title="What information we collect">
        <p>
          When you complete our quote form we collect your name, phone number, email address, property postcode or location,
          the service you are interested in, your estimated budget (if provided) and your project description.
        </p>
      </Section>

      <Section title="How we use your information">
        <p>
          We use your details only to respond to your enquiry, discuss your project and prepare a quote. Our lawful basis
          under UK GDPR is taking steps at your request before entering a contract, and our legitimate interest in running
          our business. We do not use your details for marketing lists and we never sell or share your personal data with
          third parties for their own purposes.
        </p>
      </Section>

      <Section title="How long we keep it">
        <p>
          Enquiry details are kept only for as long as needed to handle your enquiry and any resulting work, after which
          they are deleted. You can ask us to delete your details at any time.
        </p>
      </Section>

      <Section title="Your rights">
        <p>
          Under UK data protection law you have the right to access, correct or delete the personal data we hold about you,
          and to complain to the Information Commissioner's Office (ICO) at ico.org.uk if you are unhappy with how we handle it.
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          This website does not set advertising or tracking cookies of its own. If you follow our WhatsApp or phone links,
          those services' own privacy policies apply.
        </p>
      </Section>
    </section>
  );
}
